import React, {Component} from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import ContentLoader, { Rect } from 'react-content-loader';

import AuthenticationStore from '../stores/AuthenticationStore';
import { CommunicationNotices, NewContentNotices, QuestionNotices } from './notices';

@inject('NotificationStore') @observer
export default class PopupNotification extends Component {

	render() {
		const { NotificationStore, authenticationStore } = this.props;
		const tabClassName = name => (this.props.activeTab == name) ? 'active' : '';
		return (
			<section id="popup-notification-nav-btn" className="popup-generic-nav-btn">
				<ul className="notices-navbar">
					<li>
						<a onClick={e => this.props.onChangeTab('new_content_important', e)} className={tabClassName('new_content_important')}>Importante
							{ NotificationStore.unreadContentImportantNotificationsCount > 0 && <span className="badge" /> }
						</a>
					</li>
					<li>
						<a onClick={e => this.props.onChangeTab('question', e)} className={tabClassName('question')}>{AuthenticationStore.userCanAnswerQuestions ? 'Perguntas' : 'Respostas'}
							{ NotificationStore.unreadQuestionNotificationsCount > 0 && <span className="badge" /> }
						</a>
					</li>
					<li>
						<a onClick={e => this.props.onChangeTab('new_content', e)} className={tabClassName('new_content')}>Conteúdo
							{ NotificationStore.unreadContentNotificationsCount > 0 && <span className="badge" /> }
						</a>
					</li>
					<li>
						<a onClick={e => this.props.onChangeTab('notice', e)} className={tabClassName('notice')}>Comunicados
							{ NotificationStore.unreadNoticeNotificationsCount > 0 && <span className="badge" /> }
						</a>
					</li>
				</ul>
					{ this.props.activeTab === 'new_content_important' && <NewContentNotices {...this.props} category="new_content_important" />}
					{ this.props.activeTab === 'question' && <QuestionNotices {...this.props} userCanAnswerQuestions={AuthenticationStore.userCanAnswerQuestions} />}
					{ this.props.activeTab === 'new_content' && <NewContentNotices {...this.props} category="new_content" />}
					{ this.props.activeTab === 'notice' && <CommunicationNotices />}
      </section>
    )
	}
}



// WEBPACK FOOTER //
// ./src/components/PopupNotification.js